import React, { useState } from 'react'; 


function TodoItem({ todo, onDelete, onToggleCompleted, onUpdateTask }) {
    
    // --- STATES FÜR BEARBEITUNGSMODUS ---
    const [isEditing, setIsEditing] = useState(false); 
    const [newDescription, setNewDescription] = useState(todo.description);
    const [newPriority, setNewPriority] = useState(todo.priority || 'Normal');

    const enterEditMode = () => {
        setNewDescription(todo.description);
        setNewPriority(todo.priority || 'Normal');
        setIsEditing(true);
    };

    const handleSave = () => {
        if (newDescription.trim() === '') return; 
        
        onUpdateTask(todo._id, { 
            description: newDescription, 
            priority: newPriority 
        });
        
        setIsEditing(false);
    };

    const handleCancel = () => {
        setIsEditing(false); 
    };
    
    // --- ANZEIGE LOGIK ---
    const currentPriority = todo.priority || 'Normal'; 
    // ENTFERNT: currentCategory wurde entfernt
    // const currentCategory = todo.category || '';
    
    // Die Farbe für das Prioritäts-Badge bestimmen
    const getPriorityColor = () => {
        switch (currentPriority) {
            case 'High': return '#dc3545'; // Rot für Hoch
            case 'Low':  return '#28a745'; // Grün für Niedrig
            case 'Normal': default: return '#ffc107'; // Gelb für Normal
        }
    };

    // --- STYLES (auf Light Mode fixiert) ---
    const itemStyle = {
        padding: '10px',
        border: isEditing 
            ? '2px solid #5d9cec' 
            : '1px solid #ccc',
        borderRadius: '4px',
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'flex-start', 
        justifyContent: 'space-between',
        backgroundColor: isEditing 
            ? '#eaf5ff' 
            // KORREKTUR: Light mode Hintergrundfarbe
            : todo.completed 
                ? '#f0f0f0' 
                : 'white',
        overflow: 'hidden',
        transition: 'background-color 0.3s, border-color 0.3s',
    };

    const textStyle = {
        // KORREKTUR: Light mode Textfarbe
        color: '#333', 
        textDecoration: todo.completed ? 'line-through' : 'none',
        wordBreak: 'break-word',
        flexGrow: 1, 
        opacity: todo.completed ? 0.7 : 1, 
        marginRight: '10px'
    };

    const descriptionContainerStyle = {
        display: 'flex',
        alignItems: isEditing ? 'flex-start' : 'center',
        flexGrow: 1, 
    };
    
    // KORREKTUR: badgeContainerStyle neu definiert (ohne Category-Margin-Right)
    const badgeContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        marginRight: '10px' 
    };

    const priorityBadgeStyle = {
        backgroundColor: getPriorityColor(), // Dynamische Farbe
        color: 'white', 
        padding: '3px 8px',
        borderRadius: '12px',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        display: 'inline-block',
        minWidth: '50px', 
        textAlign: 'center',
    };
    
    // ENTFERNT: categoryBadgeStyle wurde entfernt
    // const categoryBadgeStyle = { ... };

    // Button Styles
    const actionButtonStyle = {
        padding: '5px 8px',
        border: 'none',
        borderRadius: '3px',
        cursor: 'pointer',
        marginLeft: '5px',
        fontWeight: 'bold',
        color: 'white'
    };
    const deleteBtnStyle = { ...actionButtonStyle, backgroundColor: '#dc3545' };
    const editBtnStyle = { ...actionButtonStyle, backgroundColor: '#212529' };
    const saveBtnStyle = { ...actionButtonStyle, backgroundColor: '#28a745' };
    const cancelBtnStyle = { ...actionButtonStyle, backgroundColor: '#ffc107', color: '#333' };

    const inputStyle = { padding: '5px', border: '1px solid #ddd', borderRadius: '3px', width: '100%' };
    const selectStyle = { padding: '5px', border: '1px solid #ddd', borderRadius: '3px', marginLeft: '10px' };


    return (
        <li className="todo-item" style={itemStyle}>
            
            <div style={descriptionContainerStyle}> 
                {!isEditing && (
                    <>
                        <input 
                            type="checkbox"
                            checked={todo.completed}
                            onChange={() => onToggleCompleted(todo._id, todo.completed)}
                            style={{ marginRight: '10px', marginTop: '3px', flexShrink: 0 }} 
                        />
                        <span style={textStyle}>
                            {todo.description}
                        </span> 
                    </>
                )}
                
                {isEditing && (
                    <input 
                        type="text"
                        value={newDescription}
                        onChange={(e) => setNewDescription(e.target.value)}
                        style={inputStyle}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleSave(); }}
                    />
                )}
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                
                {!isEditing && (
                    <>
                        {/* Die Prioritäts-Anzeige */}
                        <div style={badgeContainerStyle}>
                            {/* ENTFERNT: Das Kategorie-Badge wurde entfernt */}
                            <span style={priorityBadgeStyle}>{currentPriority}</span>
                        </div>
        
                        <button onClick={enterEditMode} style={editBtnStyle}>Edit</button>
                        <button onClick={() => onDelete(todo._id)} style={deleteBtnStyle}>Löschen</button>
                    </>
                )}
                
                {isEditing && (
                    <>
                        {/* Das Dropdown zur Änderung der Priorität im Bearbeitungsmodus */}
                        <select 
                            value={newPriority}
                            onChange={(e) => setNewPriority(e.target.value)}
                            style={selectStyle}
                        >
                            <option value="Low">Low</option>
                            <option value="Normal">Normal</option>
                            <option value="High">High</option>
                        </select>

                        {/* Speichern und Abbrechen Buttons */}
                        <button onClick={handleSave} style={saveBtnStyle}>Speichern</button>
                        <button onClick={handleCancel} style={cancelBtnStyle}>Abbrechen</button>
                    </>
                )}
            </div>
        </li>
    );
}

export default TodoItem;